import i18n, {InitOptions} from "i18next";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const FALLBACK_LANGUAGE_KEY = 'fallbackLanguage';


const fallbackLng: string = localStorage.getItem(FALLBACK_LANGUAGE_KEY) || 'en';

const options: InitOptions = {
    fallbackLng: fallbackLng,
    debug: false,
    detection: {
        order: ["querystring", "cookie"],
        caches: ["cookie"], // Corrected to "caches"
    },
    interpolation: {
        escapeValue: false, // React already escapes by default
    },
    backend: {
        loadPath: '/locales/{{lng}}/translation.json?v=3', // add query param here
    },
};

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init(options);

i18n.on('languageChanged', (lng) => {
    localStorage.setItem(FALLBACK_LANGUAGE_KEY, lng);
});


export default i18n;